import { render, staticRenderFns } from "./projectEdit.vue?vue&type=template&id=a0d1c934&scoped=true"
import script from "./projectEdit.vue?vue&type=script&lang=js"
export * from "./projectEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d1c934",
  null
  
)

export default component.exports